<template>
    <div>
        
        <!-- Filter Start -->
        <custom-filter
            :getFilterOnStart="true"
            @filterChange="changeFilter"
        ></custom-filter>
        <!-- Filter End -->

        <!-- Table Start -->
        <div class="innerBox mt-4">
            <div class="row">
                <div class="col-md-8">
                    <h5 class="elegant--sub-title">
                        Consumer Report
                        <i
                            class="fas fa-info-circle"
                            id="history-report"
                        ></i>
                        <b-popover target="history-report" triggers="hover" placement="top">
                            <template #title>Consumer Report</template>
                            <div v-html="tooltip.consumer_report"></div>
                        </b-popover>
                    </h5>
                </div>
            </div>
            <!-- <div class="row">
                <div class="col-md-10">
                    <h5 class="elegant--sub-title">History Report</h5>
                </div>
                <div class="col-md-2">
                    <button class="btn btn-elegant-download">Download Excel <i class="fas fa-download"></i></button>
                </div>
            </div> -->
            <div class="mt-3">
                <vue-universal-table
                    v-if="filterReady"
                    api_url="api/reports/customer-report/table"
                    :filter="vue_universal_table.filter"
                    :update="vue_universal_table.update"
                    :fields="vue_universal_table.fields"
                    :buttons="vue_universal_table.buttons"
                    :process_data="vue_universal_table.process_data"

                    sort_by="scan_date"
                    sort_order="DESC"

                    @onLihatGambar="openGambarModal"
                    @onViewMap="viewScanMap"
                ></vue-universal-table>
            </div>
        </div>
        <!-- Table End -->

        <!-- Modal Start -->
        <gambar-modal
            v-if="modal.gambar"
            :img="modal.gambarImg"
            @closeModal="modal.gambar = false"
        ></gambar-modal>
        <scan-map-modal
            v-if="modal.map"
            :coordinate="modal.mapData"
            @closeModal="modal.map = false"
        ></scan-map-modal>
        <!-- Modal End -->
        
    </div>
</template>

<script>
    import customFilter from '@/components/filter/customFilter'

    import gambarModal from './children/gambarModal'
    import scanMapModal from './children/scanMapModal'

    export default {
        metaInfo : {
            title : 'Report - Consumer'
        },
        data () {
            return {
                tooltip : this.$store.state.tooltip.reports,
                modal : {
                    gambar : false,
                    gambarImg : null,
                    map : false,
                    mapData : null,
                },

                filter : {},
                filterReady : false,
                vue_universal_table : {
                    fields : [
                        {title:"QR Code", variable:"url"},
                        {title:"Variant", variable:"variant"},
                        {title:"Volume", variable:"volume"},
                        {title:"Reason", variable:"reason"},
                        {title:"Description", variable:"description"},
                        {title:"Latitude", variable:"lat"},
                        {title:"Longitude", variable:"lng"},
                        {title:"Scan Date", variable:"scan_date"},
                    ],
                    filter : {},
                    update : 0,
                    buttons : [
                        {title : "viewMap", class : "fas fa-location btn-info", condition : "data.lat != 'N/A' || data.lng != 'N/A'"},
                        {title:"lihatGambar", variable:"file", class:"fas fa-image btn-primary", condition:"data.file != null"},
                    ],
                    process_data : `
                        for (var i in data) {
                            data[i].url = data[i].url ? data[i].url : 'N/A'
                            data[i].variant = data[i].variant ? data[i].variant : 'N/A'
                            data[i].volume = data[i].volume ? (parseInt(data[i].volume))/1000 + ' Lt' : 'N/A'
                            data[i].reason = data[i].reason ? data[i].reason : 'N/A'
                            data[i].description = data[i].description ? data[i].description : 'N/A'
                            data[i].lat = data[i].lat ? data[i].lat : 'N/A'
                            data[i].lng = data[i].lng ? data[i].lng : 'N/A'
                        }
                    `
                }
            }
        },
        components : {
            customFilter,

            gambarModal,
            scanMapModal,
        },
        mounted () {

        },
        methods : {
            changeFilter (filter) {
                let filters = {};

                for (var i in filter) {
                    filters[i] = filter[i];
                }

                //Delete unnecessary filter for the table
                delete filters.filter;

                this.vue_universal_table.filter = filters;
                this.vue_universal_table.update++;

                this.filterReady = true;
            },
            viewScanMap (data) {
                this.modal.mapData = JSON.parse(data);
                console.log('%cActivities.vue line:224 this.modal.mapData', 'color: #007acc;', JSON.stringify(this.modal.mapData));
                this.modal.map = true;
            },
            openGambarModal (file) {
                this.modal.gambarImg = file.replace(/"/g, "");
                this.modal.gambar = true;
            }
        }
    }
</script>

<style scoped>
    .innerBox {
        background-color: white;
        border-radius: 8px;
        box-shadow: 0px 3px 10px #0000000F;
        padding: 20px;
    }

    .elegant--sub-title {
        font-size: 18px;
        font-weight: 500;
        color: #9F9F9F;
    }

    .table td, .table th{
        text-align: center;
    }
</style>